/* HOWITWORKS */
export const GET_HOWITWORKS = "GET_HOWITWORKS"
export const GET_HOWITWORKS_SUCCESS = "GET_HOWITWORKS_SUCCESS"
export const GET_HOWITWORKS_FAIL = "GET_HOWITWORKS_FAIL"

/* HOWITWORKS PROFILE */
export const GET_HOWITWORK_PROFILE = "GET_HOWITWORK_PROFILE"
export const GET_HOWITWORK_PROFILE_SUCCESS = "GET_HOWITWORK_PROFILE_SUCCESS"
export const GET_HOWITWORK_PROFILE_FAIL = "GET_HOWITWORK_PROFILE_FAIL"

/**
 * add HOWITWORK
 */
 export const ADD_NEW_HOWITWORK = "ADD_NEW_HOWITWORK"
 export const ADD_HOWITWORK_SUCCESS = "ADD_HOWITWORK_SUCCESS"
 export const ADD_HOWITWORK_FAIL = "ADD_HOWITWORK_FAIL"

 /**
 * Edit HOWITWORK
 */
export const UPDATE_HOWITWORK = "UPDATE_HOWITWORK"
export const UPDATE_HOWITWORK_SUCCESS = "UPDATE_HOWITWORK_SUCCESS"
export const UPDATE_HOWITWORK_FAIL = "UPDATE_HOWITWORK_FAIL"

/**
 * Delete HOWITWORK
 */
export const DELETE_HOWITWORK = "DELETE_HOWITWORK"
export const DELETE_HOWITWORK_SUCCESS = "DELETE_HOWITWORK_SUCCESS"
export const DELETE_HOWITWORK_FAIL = "DELETE_HOWITWORK_FAIL"


